/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const TodoStatus = createEnum('TodoStatus', {
  INBOX: 'INBOX',
  DONE: 'DONE',
  PASSED: 'PASSED',
});

export type TodoStatus = EnumSet<typeof TodoStatus>;

export type TodoListDto = WithOptimisticLock<{
  id: ID;
  subject: string;
  message: string;
  assigneeName: string; // userName
  assignorName: string; // userName
  status: TodoStatus;
  dueDate: Date;
  activityTodo?: boolean;
}>;

export type TodoFormDto = WithOptimisticLock<{
  id: ID;
  subject: string;
  message: string;
  dueDate: Date;
  assignee?: { userId: ID; fullName?: string };
  status?: TodoStatus;
}>;

export type TodoDetailsDto = WithOptimisticLock<{
  id: ID;
  subject: string;
  message: string;
  dueDate: Date;
  userId?: ID;
  userName?: string;
  status?: TodoStatus;
  activityTodo?: boolean;
}>;

export type TodoChangeStatusRequestDto = WithOptimisticLock<{
  fromStatus: TodoStatus;
  toStatus: TodoStatus;
  todoWorkflows: Hash<string>;
  userId: Maybe<ID>;
}>;

export type TodoChangeStatusResponseDto = WithOptimisticLock<{
  status: TodoStatus;
}>;

export const toForm = ({
                         id,
                         subject,
                         message,
                         userId,
                         userName,
                         status,
                         dueDate,
                         etag,
                       }: TodoDetailsDto): TodoFormDto =>
  ({ id, subject, message, dueDate, assignee: userId ? { userId, fullName: userName } : void 0, status, etag });

export const fromForm = ({
                           id,
                           subject,
                           message,
                           assignee,
                           status,
                           dueDate,
                           etag,
                         }: TodoFormDto): TodoDetailsDto =>
  ({ id, subject, message, dueDate, userId: assignee ? assignee.userId : void 0, etag });

export type NewToDoDto = {
  count: number;
};
